export const GET_TASK_COMPLETION_STATUS = 'GET_TASK_COMPLETION_STATUS';
export const TASK_COMPLETION_STATUS_RESPONSE = 'TASK_COMPLETION_STATUS_RESPONSE';
